import React from 'react';
import styled from 'styled-components';
import {Grid} from '@material-ui/core';
import {AccentColorOptions} from 'epic-ue-theme';
import {
    CheckIcon,
    Eyebrow,
    EyebrowProps,
    RemoveIcon,
    TooltipWrap,
    Typography,
    VerticalSpacer
} from '../..';

const Styled = styled.div`
    && {
        svg {
            font-size: 1.8rem;
            margin-left: -${(p) => p.theme.spacing(0.5)}px;
        }
        .caption span {
            vertical-align: text-bottom;
        }
        height: 100%;
    }
`;

const getRadialGradient = (from, to) =>
    `radial-gradient(100% 185.14% at 100% 100%, ${from} 0%, ${to} 100%)`;

const DotGradient = styled.div<{color?: AccentColorOptions}>`
    content: '';
    position: relative;
    top: 3px;
    margin-right: 4px;
    border-radius: 100px;
    display: inline-block;
    width: 8px;
    height: 8px;
    ${(p) =>
        p.color &&
        `background: ${getRadialGradient(
            p.theme.palette.gradient[p.color].from,
            p.theme.palette.gradient[p.color].to
        )};
    `}
`;

type BulletIconOptions = 'check' | 'x' | 'dot';

export interface LicenseBulletsProps {
    icon?: BulletIconOptions;
    bulletText?: string;
    tooltip?: string;
}

export interface LicenseEyebrowBulletsProps {
    ref?: React.ForwardedRef<HTMLDivElement>;
    className?: string;
    accentColor?: AccentColorOptions;
    activeBackground?: boolean;
    eyebrow?: EyebrowProps;
    bullets?: LicenseBulletsProps[];
    height?: string;
}

export const LicenseEyebrowBullets = React.forwardRef(
    (props: LicenseEyebrowBulletsProps, ref: React.ForwardedRef<HTMLDivElement>): JSX.Element => {
        const {className, accentColor, activeBackground, eyebrow, bullets, height} = props;
        return (
            <Styled
                ref={ref}
                className={`${className || ''} License-eyebrow-bullets`}
                style={{height: height || 'initial'}}>
                {eyebrow && eyebrow.text && <Eyebrow as="span" {...eyebrow} />}
                {bullets &&
                    bullets.length &&
                    bullets.map((bullet, i) => (
                        <React.Fragment key={i}>
                            <VerticalSpacer variant="custom" spacing={2} />
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                                spacing={2}>
                                <Grid item xs={'auto'}>
                                    {bullet.icon === 'check' ? (
                                        <CheckIcon color={accentColor} />
                                    ) : bullet.icon === 'x' ? (
                                        <RemoveIcon />
                                    ) : (
                                        <DotGradient
                                            color={activeBackground ? 'black' : accentColor}
                                        />
                                    )}
                                </Grid>
                                <Grid item xs={true} style={{paddingLeft: '4px'}}>
                                    <TooltipWrap text={bullet.tooltip}>
                                        <Typography variant="p" accentColor={accentColor}>
                                            {bullet.bulletText}
                                        </Typography>
                                    </TooltipWrap>
                                </Grid>
                            </Grid>
                        </React.Fragment>
                    ))}
                <VerticalSpacer variant="custom" spacing={7} downSmSpacing={5} />
            </Styled>
        );
    }
);

LicenseEyebrowBullets.displayName = 'LicenseEyebrowBullets';
